
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adobe-analytics",
      function () {
        return require("private-next-pages/destinations/adobe-analytics.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adobe-analytics"])
      });
    }
  